import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["factoring.editNote"],
  payload => payload
);
